import { Check } from "~/pages/space/security/components/Check";
import { CheckProps } from "~/pages/space/security/components/Check/Check";

const FrameworkControlCheckEntryPage = ({ space }: CheckProps) => {
  return <Check {...{ space, scope: space }} />;
};

export default FrameworkControlCheckEntryPage;
